import React from "react";
import {Form,Button,Card,Container,Row,Col} from "react-bootstrap";
 import { useAsistencia } from '../hooks/useAsistencia';
 import { useUsuarioSistema } from '../hooks/useUsuarioSistema';
 import Select from 'react-select';
 import DataTable from "react-data-table-component";

import { useContext,useState ,useEffect} from "react";
import { AuthContext } from "auth";
import {excelExportAsistencia} from "../utils/excelExport";

// Generar lista de meses
const months = [
  { value: 1, label: "Enero" },
  { value: 2, label: "Febrero" },
  { value: 3, label: "Marzo" },
  { value: 4, label: "Abril" },
  { value: 5, label: "Mayo" },
  { value: 6, label: "Junio" },
  { value: 7, label: "Julio" },
  { value: 8, label: "Agosto" },
  { value: 9, label: "Septiembre" },
  { value: 10, label: "Octubre" },
  { value: 11, label: "Noviembre" },
  { value: 12, label: "Diciembre" },
];
const generateYears = () => {
  const startYear=2024;
  const today=new Date();
  const years = [];
  for (let year = startYear; year <= today.getFullYear(); year++) {
    years.push({value:year,label:year});
  }
  return years;
};
function Asistencia() {
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth()+1);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  //const [fechaFiltroActual,setFechaFiltroActual]=useState();
  const years = generateYears(); 

  const handleMonthChange = async(e) => {
    setSelectedMonth(e.value);
    const asistencia={
      Ano:selectedYear,
      Mes:e.value
    }
    //setFechaFiltroActual(e.value);
    await getActividadesAsistidas(asistencia);

  };
  const handleYearChange = async(e) => {
    setSelectedYear(e.value);
    const asistencia={
      Ano:e.value,
      Mes:selectedMonth
    }
    //setFechaFiltroActual(e.value);
    await getActividadesAsistidas(asistencia);
  

  };
    
    var {user}= useContext(AuthContext)
    let usuario=user.Usuario;
    const usuarioActualSistema = useUsuarioSistema({Usuario:usuario,Genero:'F',CargoId:1});
    const [columns, setColumns] = useState([]);
    const [loading, setLoading] = useState(true);
    const {  getActividadesAsistidas,columnasActividadesAsistidas,actividadesAsistidas} = useAsistencia();

    useEffect(() => {
      const loadTableData = async () => {
       
        setLoading(true);
        
        const asistencia={
          Ano:selectedYear,
          Mes:selectedMonth
        }
        await getActividadesAsistidas(asistencia);
        setLoading(false);
        return;
      };
  
      loadTableData();
    }, []);

    useEffect(() => {
      const loadTableData = async () => {
        setLoading(true);

        const dynamicColumns = [
          {
            name: "Nombre",
            selector: (row) => row.NombreCompleto,
            sortable: true,
            width: '200px',
          },
          {
            name: "Rut",
            selector: (row) => row.Rut,
            sortable: true,
          },
          ...columnasActividadesAsistidas.map((d) => ({
            name: d.dayNumber,
            cell: (row) => (
              <div>
              <label>
                {row[d.date]?.map(a => a.Sigla).join(', ')//JSON.stringify(row[d.date])//?.[0]?.Nombre
                }
              </label>
            </div>
              
            ),
            ignoreRowClick: true, 
            allowOverflow: true,
            button: true
          })),
         
        ];
        setColumns(dynamicColumns);
        setLoading(false);

      };
  
      loadTableData();
    }, [columnasActividadesAsistidas]);
    return (
      <>
        <Container fluid>
          
        <Row>
            <Col md="12">
              <Card className="strpied-tabled-with-hover">
                <Card.Header>
                  <Card.Title as="h4">Asistencia</Card.Title>
                  <p className="card-category">
                    En esta sección se puede visualizar la asistencia mensual de las actividades                  </p>
                </Card.Header>
                <Card.Body className="table-full-width table-responsive px-0">
                <div className="pull-right ml-3">
                <Form>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label>Año</label>
                        <Select
                          placeholder='Selecciona una opción' 
                          name='Agno'
                          options={years}
                          className="basic-single"
                          classNamePrefix="select"
                          value={ years.filter(i=>{ 
                                  return i.value==selectedYear;})
                          }
                          onChange={
                              (e,prop) => { handleYearChange(e); }
                          }
                          
                          />
                      </Form.Group>
                    </Col>
                    <Col md="6">
                      <Form.Group>
                        <label>Mes</label>
                        <Select
                          placeholder='Selecciona una opción' 
                          name='Mes'
                          options={months}
                          className="basic-single"
                          classNamePrefix="select"
                          value={ months.filter(i=>{ 
                                  return i.value==selectedMonth;
                              })
                          }
                          onChange={
                              (e,prop) => { handleMonthChange(e); }
                          }
                          
                          />
                      </Form.Group>
                    </Col>
                  </Row>
                
                  <DataTable
                    columns={columns}
                    data={actividadesAsistidas}
                    progressPending={loading}
                    pagination
                    highlightOnHover
                    persistTableHead
                    paginationPerPage={50}
                    paginationRowsPerPageOptions={[10, 25, 50, 100]} 
                  /> 

                </Form>

                <Button
                  className="btn-fill pull-right ml-2"
                  type="info"
                  variant="reset"
                  onClick={() => excelExportAsistencia(columns, actividadesAsistidas,columnasActividadesAsistidas,'Asistencia_'+selectedMonth+'_'+selectedYear)}
                  > <i className="fas fa-file-excel"></i> Exportar a Excel</Button>

                </div>
                </Card.Body>
              </Card>
            </Col>
        </Row>
        </Container>
      </>
    );
}
export default Asistencia;